(() => {
  const originalMedia = new WeakMap();

  function cardImageFor(swatch) {
    const dawnCard = swatch.closest('.card-wrapper')?.querySelector('.card__media img');
    if (dawnCard) return dawnCard;

    const homepageCard = swatch
      .closest('.tis-home-product')
      ?.querySelector('.tis-home-product__media img:not(.tis-home-product__secondary)');
    if (homepageCard) return homepageCard;

    return swatch.closest('.predictive-search__list-item')?.querySelector('.predictive-search__image');
  }

  function showPreview(swatch) {
    const preview = swatch.dataset.tisSiblingPreview;
    const image = cardImageFor(swatch);
    if (!preview || !image) return;

    if (!originalMedia.has(image)) {
      originalMedia.set(image, { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') });
    }

    image.removeAttribute('srcset');
    image.setAttribute('src', preview);
  }

  function restorePreview(swatch) {
    const image = cardImageFor(swatch);
    const original = image && originalMedia.get(image);
    if (!image || !original) return;

    if (original.srcset) image.setAttribute('srcset', original.srcset);
    else image.removeAttribute('srcset');
    if (original.src) image.setAttribute('src', original.src);
    originalMedia.delete(image);
  }

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest('[data-tis-sibling-preview]');
    if (swatch) showPreview(swatch);
  });
  document.addEventListener('pointerout', (event) => {
    const swatch = event.target.closest('[data-tis-sibling-preview]');
    if (swatch && !swatch.contains(event.relatedTarget)) restorePreview(swatch);
  });
  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest('[data-tis-sibling-preview]');
    if (swatch) showPreview(swatch);
  });
  document.addEventListener('focusout', (event) => {
    const swatch = event.target.closest('[data-tis-sibling-preview]');
    if (swatch && !swatch.contains(event.relatedTarget)) restorePreview(swatch);
  });
})();
